import { Component, Input } from '@angular/core';

import { StepperTabBarItemInterface } from './interfaces/item.interface';

@Component({
  selector: 'app-stepper-tab-bar',
  templateUrl: './tab-bar.component.html',
  styleUrls: ['./tab-bar.component.scss'],
})
export class StepperTabBarComponent {
  @Input() public activeIndex: number;
  @Input() public collection: StepperTabBarItemInterface[] = [];

  public get title(): string {
    const item: StepperTabBarItemInterface = this.collection[this.activeIndex];

    return item?.content || '';
  }
}
